import React, { useContext } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';

import DyteClient from '@dytesdk/web-core';
import { SvgXml } from 'react-native-svg';
import DyteText from './DyteText';
import { defaultIconPack, IconPack } from '../lib/icons';
import { States } from '../types/props';
import { DyteI18n, useLanguage } from '../lib/lang';
import { useDyteSelector } from '@dytesdk/react-native-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  size,
  variant,
  iconPack = defaultIconPack,
  states,
  t,
}: {
  meeting?: DyteClient;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  variant?: 'button' | 'horizontal';
  iconPack?: IconPack;
  states?: States;
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const waiting = useDyteSelector((m) => m.participants.waitlisted);
  const stageStatus = useDyteSelector((m) => m.stage.status);
  const stageRequested = useDyteSelector((m) =>
    m.participants.joined
      .toArray()
      .filter((p) => p.stageStatus === 'REQUESTED_TO_JOIN_STAGE')
  );
  const totalRequests = waiting.toArray().length + stageRequested.length;
  states = states ?? storeStates;
  let buttonSize = 25;
  let buttonHorizontal = false;
  switch (size) {
    case 'md':
      buttonSize = 50;
      break;
    case 'lg':
      buttonSize = 100;
      break;
    case 'xl':
      buttonSize = 150;
      break;
  }
  switch (variant) {
    case 'horizontal':
      buttonHorizontal = true;
      break;
  }
  const styles = StyleSheet.create({
    panel: {
      flexDirection: 'row',
      width: '100%',
      paddingVertical: 12,
      paddingLeft: 48,
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    wrapper: { alignItems: 'center', justifyContent: 'center' },
    button: {
      height: buttonSize * 2.1,
      width: '100%',
      backgroundColor: colors.background[1000],
    },
    text: { paddingHorizontal: 18, color: colors.text },
    requests: {
      alignItems: 'center',
      justifyContent: 'center',
      color: colors.text,
      height: 24,
      width: 24,
      borderRadius: 16,
      backgroundColor: colors.brand[300],
    },
  });
  if (
    meeting.meta.viewType === 'LIVESTREAM' &&
    !meeting.self.permissions.acceptStageRequests
  )
    return null;
  return (
    <View style={styles.wrapper}>
      {buttonHorizontal && (
        <TouchableHighlight
          underlayColor={colors.background[800]}
          onPress={() => {
            setStates({
              ...states,
              activeSidebar: true,
              activeMoreMenu: false,
              sidebar: 'participants',
            });
          }}
          style={styles.button}
        >
          <View style={styles.panel}>
            <SvgXml
              xml={iconPack.participants.replace('currentColor', colors.text)}
              width={25}
              height={25}
            />
            <DyteText style={styles.text}>{t('participants')}</DyteText>
            {stageStatus === 'ON_STAGE' && totalRequests > 0 && (
              <View style={styles.requests}>
                <DyteText>{totalRequests}</DyteText>
              </View>
            )}
          </View>
        </TouchableHighlight>
      )}
      {!buttonHorizontal && (
        <TouchableHighlight
          underlayColor={colors.background[800]}
          onPress={() => {
            setStates({
              ...states,
              activeSidebar: true,
              activeMoreMenu: false,
              sidebar: 'participants',
            });
          }}
          style={styles.button}
        >
          <View style={styles.panel}>
            <SvgXml
              xml={iconPack.participants.replace('currentColor', colors.text)}
              width={25}
              height={25}
            />
          </View>
        </TouchableHighlight>
      )}
    </View>
  );
}
